
export default {
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      options: {
        element: '.slider-container',
        container: '.slider-wrapper',
        list: '.slider',
        items: '.slide',
        progressBarContainer: '.progress-bar',
        progressBarHandle: '.progress-handle',
      },

      // animation
      progressReveal: null,
      delayedCall: null,
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.init()

      if (this.blok?.reveal_animation && this.$matchMedia('sm'))
        this.animateSlider()
    })
  },
  methods: {
    init() {
      this.createChildRefs().enable()

      return this
    },

    createChildRefs() {
      this.element = document.querySelector(this.options.element)
      this.container = this.element?.querySelector(this.options.container)
      this.list = this.element?.querySelector(this.options.list)
      this.items = [...this.element?.querySelectorAll(this.options.items)]
      this.progressBarContainer = this.element?.querySelector(
        this.options.progressBarContainer
      )
      this.progressBarHandle = this.element?.querySelector(
        this.options.progressBarHandle
      )

      this.setHandlePosition = this.$gsap.quickSetter(
        this.progressBarHandle,
        'x'
      )

      this.gridItems = this.$gsap.utils.toArray('.slide')
      this.progressReveal = this.$gsap.from('.progress-bar', {
        opacity: 0,
        duration: 0.5,
        paused: true,
      })

      return this
    },

    enable() {
      this.handleSliders()
      window.addEventListener(
        'resize',
        this.debounce(() => this.handleSliders(), 150)
      )

      return this
    },

    // handleWindowResize = debounce(() => this.handleSliders(), 200),

    handleSliders() {
      this.container.offsetWidth < this.list.offsetWidth
        ? this.initSliders()
        : this.destroySliders()
    },

    setHandleWidth() {
      this.progressBarHandle.style.width = `${
        (this.element.offsetWidth / this.list.offsetWidth) * 100
      }%`
    },

    initSliders() {
      const { onCarouselSliderMove, onProgressSliderMove } = this

      this.$gsap.set(['.slider-layout', '.slider'], {
        paddingLeft: !this.$matchMedia('sm')
          ? '32px'
          : `calc(calc(100vw - ${this.$store.state.app.containerWidth}px) / 2)`,
        paddingRight: !this.$matchMedia('sm')
          ? '32px'
          : `calc(calc(100vw - ${this.$store.state.app.containerWidth}px) / 2)`,
      })

      this.setHandleWidth()
      this.element.classList.remove('slider-container--slider-disabled')

      this.anchorSlider = this.$Draggable.create(this.container, {
        type: 'scrollLeft',
        lockAxis: true,
        inertia: true,
        throwProps: true,
        minimumMovement: 0,
        onDrag() {
          onCarouselSliderMove(this.minX, this.maxX, this.x)
        },
        onThrowUpdate() {
          onCarouselSliderMove(this.minX, this.maxX, this.x)
        },
      })[0]

      this.container.addEventListener('scroll', this.onCarouselSliderScroll)

      this.progressSlider = this.$Draggable.create(this.progressBarHandle, {
        type: 'x',
        bounds: this.progressBarContainer,
        lockAxis: true,
        throwProps: true,
        minimumMovement: 0,
        onDrag() {
          onProgressSliderMove(this.minX, this.maxX, this.x)
        },
        onThrowUpdate() {
          onProgressSliderMove(this.minX, this.maxX, this.x)
        },
      })[0]
    },

    destroySliders() {
      this.anchorSlider?.kill()
      this.progressSlider?.kill()
      this.element.classList.add('slider-container--slider-disabled')
      this.container.removeEventListener('scroll', this.onAnchorSliderScroll)
    },

    onProgressSliderMove(progressMinX = 0, progressMaxX = 0, progressX = 0) {
      const maxX = this.container.scrollWidth - this.container.clientWidth
      const normalizedProgress = this.$gsap.utils.normalize(
        progressMinX,
        progressMaxX,
        progressX
      )

      this.container.scrollTo(maxX * normalizedProgress, 0)
    },

    onCarouselSliderMove(carouselMinX = 0, carouselMaxX = 0, carouselX = 0) {
      const { maxX } = this.progressSlider
      const normalizedProgress = this.$gsap.utils.normalize(
        carouselMaxX,
        carouselMinX,
        carouselX
      )

      this.setHandlePosition(`${maxX * normalizedProgress}px`)
    },

    onCarouselSliderScroll(e) {
      // kill delayed call and restart anim on continous scroll
      this.delayedCall?.kill()

      // reveal progress bar
      if (!this.progressReveal.progress()) {
        console.log('start')
        this.progressReveal?.play()
      }

      // reverse timeline after .5 seconds
      this.delayedCall = this.$gsap.delayedCall(0.5, () =>
        this.progressReveal?.reverse()
      )

      const maxX = this.container.scrollWidth - this.container.clientWidth
      const { scrollLeft } = e.target || {}

      this.onCarouselSliderMove(-maxX, 0, -scrollLeft)
    },

    debounce(callback, wait) {
      let timeoutId = null
      return (...args) => {
        window.clearTimeout(timeoutId)
        timeoutId = window.setTimeout(() => {
          callback.apply(null, args)
        }, wait)
      }
    },

    animateSlider() {
      this.$gsap.context(() => {
        this.$gsap.set('.slide', {
          xPercent: 10,
          // autoAlpha: 0,
        })
        this.$gsap.set(this.$refs.sliderContainer, {
          xPercent: 50,
          autoAlpha: 0,
        })

        this.$gsap
          .timeline({
            scrollTrigger: {
              trigger: this.$refs.container,
              start: 'top bottom-=40%',
              end: 'top top',
              // markers: true,
            },
          })
          .to(this.$refs.sliderContainer, {
            xPercent: 0,
            autoAlpha: 1,
            duration: 0.5,
            ease: 'back.out(1.7)',
          })
          .to(
            '.slide',
            {
              xPercent: 0,
              // autoAlpha: 1,
              duration: 0.5,
              stagger: 0.08,
              ease: 'back.out(1.5)',
            },
            '0'
          )
      }, this.$refs.container)
    },
  },
}
